<script setup>
import {trackerTypes} from "@/constants/trackers";
import {useStore} from "vue2-helpers/vuex";
import {onMounted, ref, inject} from "vue";
import {accountTypeEventLimited, accountTypeFree} from "@/constants/accountTypes";

const emit = defineEmits(['setType']);
const store = useStore();

const folderType = inject("folderType");

const showTypes = ref(true);

onMounted(() => {
    if (store.getters.isEcosystem) {
        emit('setType', trackerTypes.PRIVATE);
    } else if (folderType === trackerTypes.PUBLIC) {
        emit('setType', trackerTypes.PUBLIC)
    } else if (store.getters.settings['enable_projects']) {
        showTypes.value = false;
    }
})

function trackerSelected() {
    if (
        [accountTypeFree, accountTypeEventLimited].includes(store.state.accountType)
        || (store.getters.isCollinsEnterprise && !store.getters.isAdmin)
    ) {
        emit('setType', trackerTypes.PRIVATE)
    } else {
        showTypes.value = true;
    }
}

defineExpose({
    showTypes
});
</script>

<template>
    <div class="modal-sub modal-sub--dark">
        <h1 class="modal__title modal__title--primary pt-sm-5 mt-0">Create New Tracker</h1>

        <template v-if="showTypes">
            <ul class="create-tracker-list">
                <li class="create-tracker-list__blank">
                    <a @click="emit('setType', trackerTypes.PUBLIC)">
                        <h4 class="heading4">Public Challenge</h4>
                        <p>Startups can find your project and apply</p>
                    </a>
                </li>

                <li v-if="store.getters.isCoPaceEnterprise" class="create-tracker-list__template">
                    <a @click="emit('setType', trackerTypes.REQUEST)">
                        <h4 class="heading4">Request</h4>
                        <p>Problem Statement / Opportunity Statement</p>
                    </a>
                </li>

                <li class="create-tracker-list__template">
                    <a @click="emit('setType', trackerTypes.PRIVATE)">
                        <h4 class="heading4">Private Tracker</h4>
                        <p>Users within your company add and evaluate startups</p>
                    </a>
                </li>
            </ul>

            <div v-if="store.getters.isEnterprise" class="create-tracker-alternative">
                <div class="create-tracker-alternative__or">- Or -</div>

                <b-dropdown text="More Tracker Types" class="dropdown-tracker">
                    <b-dropdown-item
                        v-if="!store.getters.settings.disable_ecosystems_trackers"
                        @click="emit('setType', trackerTypes.ECOSYSTEMS)"
                    >
                        <h4 class="heading4">Ecosystem Tracker</h4>

                        <p>Follow VCs, universities, etc, & their startups</p>
                    </b-dropdown-item>

                    <b-dropdown-item class="dropdown-tracker__poc" @click="emit('setType', trackerTypes.POC)">
                        <h4 class="heading4">POC Tracker</h4>

                        <p>View POCs in a time-based layout</p>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </template>

        <template v-else>
            <ul class="create-tracker-list">
                <li class="create-tracker-list__tracker">
                    <a @click="trackerSelected">
                        <h4 class="heading4">Startup Tracker</h4>
                        <p>Advance startups in a funnel as you assess them</p>
                    </a>
                </li>

                <li class="create-tracker-list__project">
                    <a @click="emit('setType', trackerTypes.PROJECT)">
                        <h4 class="heading4">Project</h4>
                        <p>Track your team’s tasks</p>
                    </a>
                </li>
            </ul>
        </template>
    </div>
</template>

<style scoped>

</style>
